var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addressPostcardView" }, [
    _c("div", { staticClass: "introText" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.$t("confirmPostcardAddress")) + "\n\t"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "address" },
      _vm._l(_vm.addressLines, function (addressLine, index) {
        return _c("span", { key: index }, [
          _vm._v("\n\t\t\t" + _vm._s(addressLine)),
          _c("br"),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }